import React from "react";
import "./ProviderDetailsComponent.scss";
import {ImageConfig} from "../../../../constants";
import {CommonService} from "../../../../shared/services";
import SkeletonCard from "../../../../shared/components/skeleton-card/SkeletonCard";

interface ProviderDetailsModalProps {
    setIsProviderDetailsModalOpen?: any;
    providerDetails?: any;
    setSelectedScreen?: any;
    isProviderDetailsLoading?: any;
    setInternalScreen?: any
}


const ProviderDetailsModalComponent = ((props: ProviderDetailsModalProps) => {
    const {
        providerDetails,
        setIsProviderDetailsModalOpen,
        setSelectedScreen,
        isProviderDetailsLoading,
        setInternalScreen
    } = props;

    return (
        <div className="provider-details-modal ">
            {isProviderDetailsLoading &&
                <SkeletonCard/>
            }
            {!isProviderDetailsLoading && <div className={'d-flex'} style={{height: "100%"}}>
                <div
                    className="flex-1 d-flex justify-content-center align-items-center provider-profile-details-holder">
                    <div className={'provider-profile-details'}>
                        <div className={'provider-profile-image'}>
                            <img src={ImageConfig.ProviderProfileImage} alt="book_aponitment_icon_male"/>
                        </div>
                        <div
                            className={'d-flex justify-content-center align-items-center flex-direction-column mrg-top-30'}>
                            <div className={'provide-name-text'}>
                                {providerDetails?.first_name}&nbsp;{providerDetails?.last_name}
                            </div>
                            <div className={'provider-professional-credentials-holder mrg-top-10'}>
                                <div>
                                    {providerDetails?.professional_designation && providerDetails?.professional_designation}
                                </div>
                                <div>
                                    {providerDetails?.credentials && providerDetails?.credentials}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex-1 provider-basic-details-holder">
                    <div className={'provider-basic-details pdd-30'}>
                        <div className={'d-flex justify-content-right cursor-pointer mrg-bottom-25'} onClick={() => {
                            setIsProviderDetailsModalOpen(false)
                            if (setSelectedScreen) {
                                setSelectedScreen("provider_selection")
                            } else {
                                setInternalScreen("select-provider")
                            }
                            console.log(setInternalScreen)
                        }}>
                            <ImageConfig.CloseIcon color={"#1479FF"}/>
                        </div>
                        <div className={'details-label-header'}>
                            About
                        </div>
                        <div className={'details-description-text mrg-top-10'}>
                            <div dangerouslySetInnerHTML={{__html: providerDetails?.summary || 'N/A'}}/>
                        </div>

                        <div className={'details-label-header mrg-top-25'}>
                            Specialties
                        </div>
                        {providerDetails && providerDetails?.specialities?.length === 0 &&
                            <div className={'details-description-text mrg-top-10 mrg-right-15'}>
                                No Speciality Available
                            </div>}
                        <div className={'d-flex'}>
                            {providerDetails && providerDetails?.specialities?.map((name: any) => {
                                return (
                                    <div className={'card-for-name mrg-top-10 mrg-right-15'}>
                                        {name}
                                    </div>
                                )
                            })}
                        </div>
                        <div className={'details-label-header mrg-top-25'}>
                            Languages
                        </div>
                        {providerDetails && providerDetails?.languages?.length === 0 &&
                            <div className={'details-description-text mrg-top-10 mrg-right-15'}>
                                No Language Available
                            </div>}
                        <div className={'details-description-text mrg-top-10'}>
                            {providerDetails?.languages?.map((language: any) => {
                                return (
                                    <div className={'mrg-bottom-5'}>
                                        {CommonService.capitalizeFirstLetterAndRemoveUnderScore(language?.language_details?.title || language?.name)}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    )
})

export default ProviderDetailsModalComponent;


